import React from "react";
import { gettext } from "../../adapter";
import AllStationsListHead from "./AllStationsListHead";
import AllStationsListItem from "./AllStationsListItem";

const AllStationsList = ({ sensors }) => {
  var items;
  if (sensors.length > 0) {
    items = sensors.map(function (item) {
      return <AllStationsListItem sensor={item} key={item.id} />;
    });
  } else {
    items = (
      <tr>
        <td colSpan="4">
          <span className="no-results">
            {gettext("Your search did not match any sensors. Please extend your search filter.")}
          </span>
        </td>
      </tr>
    );
  }

  return (
    <div className="table-wrapper">
      <table className="table--moisture">
        <AllStationsListHead />
        <tbody>{items}</tbody>
      </table>
    </div>
  );
};

export default AllStationsList;
